// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"261102d0","831":"931c74c1"}[chunkId] + ".chunk.css";
};